/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { flattenDependencies } from './dependenciesFlatten.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMatrixFromColumns } from '../../factoriesAny.js';
export var matrixFromColumnsDependencies = {
  flattenDependencies,
  matrixDependencies,
  sizeDependencies,
  typedDependencies,
  createMatrixFromColumns
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMatrixFromColumns.generated.js
// module id = 367
// module chunks = 2